import { orderBookComponents } from "./orders/navigationComponents";
import { tradesComponents } from "./trades/navigationComponents";
import { mainBoardComponents } from "./mainBoard/navigationComponents";
import { portfolioReportComponents}  from "./portfolio/navigationComponents"

export const domesticComponents = [...orderBookComponents, ...tradesComponents, ...mainBoardComponents, ...portfolioReportComponents,];
